import { Button, TextField } from "@material-ui/core";
import React from "react";
import { graphql, gql, ChildProps } from "react-apollo";
import handleMutationError from "../../../utils/handleMutationError";
import withDialog, { DialogProp } from "app/utils/withDialog";

type MutationResult = {
  resume_withdrawal_request: {
    id: string;
  };
};

type Props = ChildProps<
  {
    withdrawalReference: string;
    onAction: () => void;
  } & DialogProp,
  MutationResult
>;

type State = {
  comment: string;
};

class ResumeWithdrawalButton extends React.Component<Props, State> {
  state = {
    comment: null,
  };

  resume() {
    this.props.dialog.prompt({
      content: (
        <div>
          <label
            style={{
              color: "black",
            }}
          >
            Comment:{" "}
          </label>
          <TextField
            multiline
            type="text"
            onChange={(event) => this.setState({ comment: event.target.value })}
            style={{
              width: "200px",
              marginRight: "10px",
            }}
          />
        </div>
      ),
      buttons: [
        {
          label: "Save",
          action: this.saveAction.bind(this),
        },
        {
          label: "Cancel",
        },
      ],
    });
  }

  saveAction() {
    this.props
      .mutate({
        variables: {
          reference: this.props.withdrawalReference,
          comment: this.state.comment,
        },
      })
      .then(() => this.props.onAction && this.props.onAction())
      .catch((error) => error && handleMutationError(error));
  }

  render() {
    return (
      <Button
        style={{
          backgroundColor: "#4d5a86",
          color: "white",
          margin: "auto 0.25em",
        }}
        onClick={() => this.resume()}
      >
        Resume
      </Button>
    );
  }
}

const withResumeWithdrawalMutation = graphql<MutationResult, Props>(
  gql`
    mutation ResumeWithdrawalRequest($reference: ID!, $comment: String) {
      resume_withdrawal_request(reference: $reference, comment: $comment) {
        id
      }
    }
  `
);

export default withDialog(withResumeWithdrawalMutation(ResumeWithdrawalButton));
